<library-card
  *ngIf="showLibraryCard"
  [id]="libraryCardId"
  [library]="libraryCardLibraryName"
  (closed)="closeLibraryCard()"
>
</library-card>

<!-- ng bootstrap modal -->
<ng-template #content id="Modal" let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Hello User</h4>
    <button
      role="button"
      aria-label="Close"
      type="button"
      class="close"
      aria-label="Close"
      (click)="d('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p></p>
    <p></p>
  </div>
  <div class="modal-footer">
    <button
      role="button"
      aria-label="Continue"
      type="button"
      class="btn btn-outline-success"
      (click)="c('Close click')"
    >
      Continue with my current session
    </button>
    <button
      role="button"
      aria-label="Log Out"
      type="button"
      class="btn btn-outline-success"
      (click)="c('Close click')"
    >
      Logout
    </button>
  </div>
</ng-template>

<span class="skipnav">
  <a id="skip2Search" class="pointer" tabindex="0" (agInteract)="sideNav.close(); skip2Search()"
    >Skip to search
  </a>
  <a id="skip2Content" class="pointer" tabindex="0" (agInteract)="sideNav.close(); skip2Main()"
    >Skip to main content
  </a>
  <a id="skip2Nav" class="pointer" tabindex="0" (agInteract)="sideNav.close(); header.focus()"
    >Skip to navigation
  </a>
</span>

<ag-header
  *ngIf="!hideHeader"
  #header
  tabindex="-1"
  [menuItems]="menuItems"
  (tracking)="sideNav.close(); trackingSummary($event); sideNav.open()"
>
</ag-header>
<mat-sidenav-container>
  <mat-sidenav
    #sideNav
    fixedInViewport="true"
    [fixedTopGap]="layoutService.headerHeight$ | async"
    ngClass="sidenav-height"
    role="navigation"
    (closedStart)="resetA11y()"
    [ngClass]="{
      'remove-colors': (layoutService.sideNavConfig$ | async)?.template === 'resources',
      'width-75': (layoutService.sideNavConfig$ | async)?.template === 'resources'
    }"
  >
    <ng-container
      *ngIf="layoutService.sideNavConfig$ | async as config"
      [ngSwitch]="config.template"
    >
      <!-- RESOURCES -->
      <div *ngSwitchCase="'resources'">
        <div fxLayout="row">
          <div fxFlex>
            <h4 class="ag-ml-md">Resources</h4>
          </div>
          <div fxFlex="nogrow">
            <button
              mat-icon-button
              aria-label="Close Resources"
              type="button"
              (click)="sideNav.close()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="ag-pa-md">
          <app-search-resources></app-search-resources>
        </div>
      </div>

      <!-- Search List template -->
      <add-list *ngSwitchCase="'addList'" [item]="config.data"></add-list>

      <!-- QUICK MENU -->
      <quick-menu *ngSwitchCase="'quickmenu'"></quick-menu>

      <!-- NOTIFICATIONS -->
      <notify *ngSwitchCase="'notify'" [trigger]="trigger" [notifications]="notifications"></notify>

      <!-- Guest ILL Tracking -->
      <guest-ill-tracking *ngSwitchCase="'tracking'" [tracking]="config.data"></guest-ill-tracking>

      <!-- SEARCH HISTORY -->
      <search-history *ngSwitchCase="'history'" [searchHistrory]="searchHistory"></search-history>

      <!-- SEND EMAIL -->
      <send-email *ngSwitchCase="'email'" [email]="config.data"></send-email>

      <!-- SEND SMS -->
      <ag-send-sms *ngSwitchCase="'sms'" [sms]="config.data"></ag-send-sms>

      <!-- PERMANENT LINK-->
      <copy-link *ngSwitchCase="'copyLink'" [links]="config.data"></copy-link>

      <!-- SETTINGS -->
      <ag-edit-sidenav *ngSwitchCase="'page'" [trigger]="trigger"></ag-edit-sidenav>

      <!-- SELECT A PATRON -->
      <ag-patron-search
        *ngSwitchCase="'patron'"
        [isInSideNav]="true"
        [canReserve]="config.data"
      ></ag-patron-search>

      <!-- STAFF - full record  -->
      <staff-full-record
        *ngSwitchCase="'staffFullRecord'"
        [staff]="config.data"
      ></staff-full-record>

      <!-- STAFF - dashboard links -->
      <staff-menu *ngSwitchCase="'staffMenu'" [menu]="config.data"></staff-menu>

      <!-- PAGE TEMPLATES -->
      <edit-page *ngSwitchCase="'pages'"></edit-page>

      <!-- ADD - ROWS -->
      <edit-row *ngSwitchCase="'row'" [row]="config.data"></edit-row>

      <!-- EDIT COMPONENT -->
      <edit-component *ngSwitchCase="'comp'" [component]="config.data"></edit-component>

      <!-- FORGOT PASSWORD -->
      <ag-forgot-password *ngSwitchCase="'f-pass'" [lid]="config.data"></ag-forgot-password>

      <!-- USER - PROFILE AND NAVIGATION -->
      <ag-profile-nav
        *ngSwitchDefault
        [pages]="activePages"
        [a11y]="a11y"
        (resetA11y)="resetA11y()"
        (toggleSideNav)="sideNav.close(); setPosition($event); sideNav.open()"
        (openLibraryCard)="openLibraryCard($event)"
      ></ag-profile-nav>
    </ng-container>
  </mat-sidenav>

  <!-- Main Scrolling Element - 100% vertical height minus layout header-->
  <mat-sidenav-content
    id="app-body"
    [ngStyle]="{
      height: 'calc(100dvh - ' + (layoutService.headerHeight$ | async) + 'px)',
      'margin-top.px': (layoutService.headerHeight$ | async)
    }"
    (scroll)="setContentScrollOffset($event)"
  >
    <!-- main-content - 100% vertical height minus layout header, so that the footer can be positioned at
      the bottom of the screen.
      Redundant with app-body, but needed for legacy id selector and bg manipulation.
      Should be worked out. -->
    <div
      id="main-content"
      [ngClass]="{
        'kids-body': (sharedService.kidsCat$ | async)
      }"
      [ngStyle]="{
        position: 'relative',
        'min-height': 'calc(100dvh - ' + (layoutService.headerHeight$ | async) + 'px)'
      }"
    >
      <!-- Router Outlet - Handles outlet display and bottom offset -->
      <div
        #pageContainer
        class="ag-page-container"
        tabindex="-1"
        [ngStyle]="{
          'padding-bottom.px': (layoutService.footerHeight$ | async),
          'display ': staffMenuItem ? 'none' : 'block'
        }"
      >
        <router-outlet (activate)="onRouteActivate($event)"> </router-outlet>
      </div>
      <!-- Staff Content - 100% vertical height minus layout header -->
      <div
        #staffPageContainer
        *ngIf="staffMenuItem"
        class="ag-page-container"
        tabindex="-1"
        [ngStyle]="{
          'min-height': 'calc(100dvh - ' + (layoutService.headerHeight$ | async) + 'px)',
          'display ': staffMenuItem ? 'block' : 'none'
        }"
      >
        <ag-staff-content [staffMenu]="staffMenuItem"> </ag-staff-content>
      </div>
      <footer #footer style="position: absolute; bottom: 0; left: 0; right: 0">
        <div *ngIf="showCopyRights && !staffMenuItem" class="ag-copyright padding-0-15">
          VERSO™, SHAREit™, AGent Library Management Platform™, AGent™, Impact™, RESEARCHit™,
          AGCat™, and MARCit™ are trademarks of Auto-Graphics, Inc. Fontana, CA. All Rights
          Reserved. Copyright © {{ DATE?.getFullYear() }}.
        </div>
        <ag-footer
          *ngIf="!staffMenuItem && !hideFooter"
          aria-label="footer"
          class="no-print"
        ></ag-footer>
      </footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<ag-page-sticky *ngIf="showBackToTop" [offset]="[18, 18]">
  <button
    *ngIf="(layoutService.contentScrollOffset$ | async) > 0"
    mat-fab
    type="button"
    class="ag-mat-button-primary"
    [@fadeInOut]
    (click)="layoutService.scrollContentToTop()"
  >
    <mat-icon>expand_less</mat-icon>
  </button>
</ag-page-sticky>
